import { render } from "./ClientIconSmall.vue?vue&type=template&id=26eb7ada&ts=true&lang=pug"
import script from "./ClientIconSmall.vue?vue&type=script&lang=ts"
export * from "./ClientIconSmall.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__